<template>

  <div class="custom-table">
    <vxe-table border show-overflow ref="xTable" style="max-height: 400px;overflow-y: auto;" :data="tableData">
      <!-- <vxe-table-column field="sort" width="160" align="center" title="类型">
        <template v-slot="{ row }">
            {{row.dataType === '1'?'商品' : '产品层级'}}
        </template>
      </vxe-table-column> -->
      <vxe-table-column type="seq" width="50" align="center" title="序号">
      </vxe-table-column>
      <vxe-table-column field="seriesCode" align="center" title="产品系列编码">
      </vxe-table-column>
      <vxe-table-column field="seriesName" align="center" title="产品系列名称">
      </vxe-table-column>
      <vxe-table-column v-if="!disabled" field="operate-btn" align="center" width="60"  title="操作">
        <template v-slot="{rowIndex}">
          <div class="setting-btn">
            <Popconfirm
              title="确定删除该数据？"
              confirm-button-type="text"
              @confirm="deleteItem(rowIndex)"
            >
              <el-button slot="reference" type="text">
                <i class="el-icon-delete" style="color: #f5222d"></i>
              </el-button>
            </Popconfirm>
          </div>
        </template>
      </vxe-table-column>
    </vxe-table>
  </div>

</template>

<script>
import { Popconfirm } from 'element-ui';

export default {
  props: {
    data: Array,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Popconfirm,
  },
  data() {
    return {
      tableData: [],
    };
  },
  watch: {
    data: {
      deep: true,
      immediate: true,
      handler(v) {
        console.log(v);
        this.tableData = this.data || [];
      },
    },
  },
  methods: {
    deleteItem(rowIndex) {
      this.$emit('deleteItem', rowIndex);
    },
  },

};
</script>

<style>

</style>
